import { useState } from "react";
import { Grid } from "@mui/material";

import {
  FormTitle,
  DatePickerField,
  Text,
  SelectField,
  ReadOnlyTextField,
} from "ui-components/Form";
import MDBox from "components/MDBox";
import { useSKUOptions } from "hooks/useQueryHook";
import { useQuery } from "@tanstack/react-query";
import { getPackTypeUOM } from "services/data.internal.service";
import { numberValidation } from "layouts/views/common/validation";

function PODetail({
  detailRender,
  values,
  control,
  errors,
  setValue,
  getValues,
  onError,
  mode = "ADD",
}) {
  const { skuCode, customerCode, vendorCode } = values;
  const [status, newItem] = getValues(["status", "newItem"]);
  const [skuOptions, setSKUOptions] = useState([]);
  const [uomOptions, setUOMOptions] = useState([]);

  // useEffect(() => {
  //   if (status !== "Open" || poQty === 0) return;
  //   const uom = poUOM;
  //   const quantity = poQty * (uom ? uom.value : 0);
  //   setValue("qtyOrdered", quantity);
  // }, [poQty]);

  // useEffect(() => {
  //   if (status !== "Open" || poUOM === null) return;
  //   const uom = poUOM ? poUOM.value : 0;
  //   const quantity = poQty * uom;
  //   setValue("qtyOrdered", quantity);
  // }, [poUOM]);

  const onQtyChange=(e)=>{
    const {value}=e.target
    const qty = numberValidation(value)
    const poUOM = getValues("poUOM")
    const uom = poUOM?poUOM.value:0
    setValue("poQty",qty,{shouldDirty:true})
    setValue("qtyOrdered",qty*uom)
  }
  const onUOMChange=(e,option)=>{
    setValue("poUOM",option,{shouldDirty:true})
    const uom = option?option.value:0
    const poQty = getValues("poQty")
    setValue("qtyOrdered",poQty*uom)
  }

  const onSKUChange = (e, option) => {
    setUOMOptions([]);
    setValue("qtyOrdered", 0);
    setValue("poQty", 0);
    setValue("poUOM", null);
    setValue("baseUOM", null);
    setValue("packType", null);
    setValue("skuCode", option.value);
    setValue("skuDescription", option.description);
    setValue("currencyCode", option.currencyCode);
  };

  useSKUOptions({
    customerCode,
    onSuccess: (data) => {
      setSKUOptions(
        data.data.data.map((x) => {
          return {
            label: x.skuCode,
            value: x.skuCode,
            description: x.descriptions1,
            currencyCode: x.currencyCode,
          };
        })
      );
    },
  });

  const enabled = Boolean(skuCode && customerCode && vendorCode && status === "Open");

  useQuery({
    queryKey: ["pack-type-uom", { skuCode, customerCode, vendorCode }],
    queryFn: () => getPackTypeUOM({ skuCode, customerCode, vendorCode }),
    enabled,
    onSuccess: (data) => {
      const { packType, baseUOM, uomOptions: options } = data.data.data;
      setValue("packType", packType);
      setValue("baseUOM", baseUOM);
      setUOMOptions(options.map((x) => ({ value: x.upm, label: x.uom })));
    },
  });

  function renderFn(property, index, length) {
    const { size, disabled, editable, ...data } = property;
    const xs = 6/2
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
      ...(mode === "EDIT" &&
        newItem === false &&
        editable === false && { disabled: true, type: "text" }),
      ...(mode === "EDIT" && status !== "Open" && { disabled: true, type: "readonly" }),
      ...(data.name==="poQty" && {onChange:onQtyChange})
    };
    let renderField;
    switch (fieldProps.type) {
      case "text":
      case "number":
        renderField = <Text field={fieldProps} />;
        break;
      case "readonly":
        renderField = <ReadOnlyTextField field={fieldProps} />;
        break;
      case "select":
        let options = [];
        let onChange = null;
        switch (data.name) {
          case "skuCode":
            options = skuOptions;
            onChange = onSKUChange;
            break;
          case "poUOM":
            options = uomOptions;
            onChange=onUOMChange
            break;
        }
        renderField = <SelectField field={fieldProps} options={options} onChange={onChange} />;
        break;
      case "date":
        renderField = <DatePickerField field={fieldProps} />;
        break;
    }
    return (
      <Grid key={index} item xs={xs}>
        {renderField}
      </Grid>
    );
  }
  return (
    <MDBox>
      <FormTitle
        title={mode === "EDIT" ? "Edit Purchase Order Detail" : "Add Purchase Order Detail"}
      />
      <MDBox mt={1.625}>
        {detailRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((row, index) => renderFn(row, index, rows.length))}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default PODetail;

// const onUOMChange=(e,option)=>{
//   const quantity=getValues("poQty")*option.value
//   setValue("qtyOrdered",quantity)
//   setValue("poUOM",option)

// }
// const onQtyChange=(e)=>{
//   const{value}=e.target
//   setValue("poQty",value)
//   const uom=getValues("poUOM")
//   const quantity=value*(uom?uom.value:0)
//   if(quantity!==0) setValue("qtyOrdered",quantity)

// }
// useSKUPackUOM({
//   skuCode:values.skuCode,
//   custCode:values.customerCode,
//   vendCode:values.vendorCode,
//   onSuccess:(data)=>{
//     const{packType,baseUOM,uomOptions:options}=data.data.data

//   setValue("packType",packType)
//   setValue("baseUOM",baseUOM)
//   setUOMOptions(options.map(x=>{
//     return{
//       value:x.upm,
//       label:x.uom
//     }
//   }))
// },
//   onError
// })
